import {Injectable, Injector} from '@angular/core';
import {EntityCollectionServiceElementsFactory} from '@ngrx/data';
import {AbstractRepositoryV2} from "../../../../../../core/service/v2/abstractRepositoryV2";
import {AudioTranscriptionModel} from "../../../api/model/audioTranscription.model";

@Injectable({
    providedIn: 'root'
})
export class AudioTranscriptionRepository extends AbstractRepositoryV2<AudioTranscriptionModel> {
    constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory, injector: Injector) {
        super('AudioTranscription', serviceElementsFactory, injector);
    }
}
